import { DataRecord, RecordKind } from './record.js';
import { optionIdSymbol, typeSymbol } from './engine-impl.js';
export class Option extends DataRecord {
    constructor(_class, model, id) {
        super(_class, RecordKind.Option, id);
        this.model = model;
        if (id) {
            this.model[optionIdSymbol] = id;
        }
        this.model[typeSymbol] = _class.typeRef;
    }
}
export class OptionWithSources extends Option {
    constructor(_class, model, sources, id) {
        for (let sv of Object.keys(sources)) {
            if (sources[sv] instanceof SourcedValue) {
                if (Array.isArray(sources[sv].value)) {
                    model[sv] = sources[sv].value.map(v => v.model);
                }
                else {
                    model[sv] = sources[sv].value.model;
                }
            }
            else {
                model[sv] = sources[sv].value;
            }
        }
        super(_class, model, id);
        this.sources = sources;
    }
}
export class OptionGroup extends DataRecord {
    constructor(_class, children, model, id) {
        super(_class, RecordKind.OptionGroup, id);
        this.children = children;
        this.model = model;
    }
}
export class ListSourcedValue {
    constructor(value, sources) {
        this.value = value;
        this.sources = sources;
    }
    getSource(p1) {
        return this.sources[p1] ? this.sources[p1].getSource() : [];
    }
    getOptionAvailability(p1) {
        return this.sources[p1] && this.sources[p1].getOptionAvailability();
    }
}
export class Source {
    constructor(source, optionAvailability) {
        this.source = source;
        this.optionAvailability = optionAvailability;
    }
    getSource(p1) {
        return this.source;
    }
    getOptionAvailability(p1) {
        return this.optionAvailability;
    }
}
export class SourcedValue extends Source {
    constructor(value, source = null, optionAvailability) {
        let nsource;
        if (source == null) {
            if (Array.isArray(value)) {
                nsource = value;
            }
            else {
                nsource = [value];
            }
        }
        else {
            nsource = source;
        }
        super(nsource, optionAvailability);
        this.value = value;
    }
    hasSourceWithId(id) {
        return this.getSource().some(sourcedValue => sourcedValue._id === id);
    }
}
export class LazySourcedValue extends SourcedValue {
    constructor(value, sourceOptionIds, sourceFn = null, optionAvailability) {
        super(value, null, optionAvailability);
        this.sourceOptionIds = sourceOptionIds;
        this.sourceFn = sourceFn;
        this.initialized = false;
    }
    hasSourceWithId(id) {
        return this.sourceOptionIds.includes(id);
    }
    getSource(p1) {
        if (!this.initialized) {
            this.source = this.sourceFn();
            this.initialized = true;
        }
        return super.getSource(p1);
    }
}
export function sourcedValueGuard(v) {
    return typeof v === 'object' && v.hasOwnProperty('source') && Array.isArray(v['source']) && v.hasOwnProperty('value');
}
//# sourceMappingURL=option.js.map